import script from "./fw_specific_commercial_transaction.vue?vue&type=script&setup=true&lang=js"
export * from "./fw_specific_commercial_transaction.vue?vue&type=script&setup=true&lang=js"

import "./fw_specific_commercial_transaction.vue?vue&type=style&index=0&id=3f0ce9fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0ce9fa"]])

export default __exports__